var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselFlaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8917_8133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 10.9987V3.75H23.75V0H6.25V3.75H8.75V10.9987C6.46625 12.9612 0 18.9963 0 24.375C0 27.6475 2.4475 29.3825 3.89375 29.8938L4.19625 30H25.8025L26.105 29.8938C27.5513 29.3838 29.9988 27.6475 29.9988 24.375C29.9988 18.9975 23.5338 12.9625 21.25 10.9987ZM25.0813 26.25H4.91875C4.49375 26.02 3.75 25.4638 3.75 24.375C3.75 23.45 4.1375 22.375 4.765 21.25H22.2913C21.465 20.0712 20.3475 18.7575 19.0888 17.5H7.4975C8.9275 15.8675 10.52 14.3712 11.8025 13.3337L12.5 12.77V3.75H17.5V12.7712L18.1975 13.3337C21.3113 15.8512 26.25 21.075 26.25 24.375C26.25 25.4638 25.5063 26.02 25.0813 26.25Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2913 21.25H4.765L7.4975 17.5H19.0888C20.3475 18.7575 21.465 20.0712 22.2913 21.25Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8917_8133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselFlaskIcon);
export default __webpack_public_path__ + "static/media/carousel-flask-icon.22e749ec670b730efe30aadd19e5cf06.svg";
export { ForwardRef as ReactComponent };